function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" {...props}><path d="M43.585 41.581l-1.627-1.162L51.543 27l-9.585-13.419 1.627-1.162L54 27zM10.415 41.581l1.627-1.162L2.457 27l9.585-13.419-1.627-1.162L0 27zM17.14 41.483l18.003-29.997 1.715 1.03-18.004 29.996z" /></svg>;
});